import "./BakersJournal.module.css";
import Header from "@/reusable_sections/Header";
import UltimasDoBlog from "./sections/UltimasDoBlog";
import SupportLocalSound from "./sections/SupportLocalSound";
import Footer from "@/reusable_sections/Footer";
export default function BakersJournalPage() {
  return <div>
      <Header />
      <UltimasDoBlog />
      <SupportLocalSound />
      <Footer />
    </div>;
}